// 引用模板
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const Layout = resolve => require(['../views/Layout'], resolve);
const Main = resolve => require(['../views/main'], resolve);

const HelpSum = resolve => require(['../views/help'], resolve);
const Help01 = resolve => require(['../views/help/help01'], resolve);
const Help02 = resolve => require(['../views/help/help02'], resolve);
const Help03 = resolve => require(['../views/help/help03'], resolve);

const ProductSum = resolve => require(['../views/product'], resolve);
const Product01 = resolve => require(['../views/product/product01'], resolve);
const Product02 = resolve => require(['../views/product/product02'], resolve);
const Product03 = resolve => require(['../views/product/product03'], resolve);
const Product04 = resolve => require(['../views/product/product04'], resolve);

const Clause01 = resolve => require(['../views/clause/clause01'], resolve);
const Clause02 = resolve => require(['../views/clause/clause02'], resolve);
const Clause03 = resolve => require(['../views/clause/clause03'], resolve);
const Clause05 = resolve => require(['../views/clause/clause05'], resolve);
const ClauseMc1 = resolve => require(['../views/clause/clauseMc1'], resolve);
const ClauseMc2 = resolve => require(['../views/clause/clauseMc2'], resolve);
const ClauseMc3 = resolve => require(['../views/clause/clauseMc3'], resolve);
const Clause06 = resolve => require(['../views/clause/clause06'], resolve);
const Clause07 = resolve => require(['../views/clause/clause07'], resolve);

const AboutSum = resolve => require(['../views/about'], resolve);
const About01 = resolve => require(['../views/about/about01'], resolve);
const About02 = resolve => require(['../views/about/about02'], resolve);
const About03 = resolve => require(['../views/about/about03'], resolve);
const About04 = resolve => require(['../views/about/about04'], resolve);

const TrackingSum = resolve => require(['../views/tracking'], resolve);
const Tracking = resolve => require(['../views/tracking/tracking01'], resolve);
const tracking02 = resolve => require(['../views/tracking/tracking02'], resolve);
const tracking03 = resolve => require(['../views/tracking/tracking03'], resolve);
const tracking04 = resolve => require(['../views/tracking/tracking04'], resolve);
const tracking05 = resolve => require(['../views/tracking/tracking05'], resolve);

const NewsSum = resolve => require(['../views/news'], resolve);
const News01 = resolve => require(['../views/news/news01'], resolve);
const News02 = resolve => require(['../views/news/news02'], resolve);
const Detail01 = resolve => require(['../views/detail/detail01'], resolve);
const Detail02 = resolve => require(['../views/detail/detail02'], resolve);



let RouterConfig = {};
if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'testing'){
  RouterConfig.mode = 'history'
}

RouterConfig.routes = [
  {
    path: '/layout',
    component: Layout,
    children:[{
      path: '/NewsSum',
      component: NewsSum,
      children:[{
        path: '/NewsSum',
        redirect: '/news'
      },{
        path:'/news',
        component:News01
      },{
        path:'/newsCompany',
        component:News02
      }]
    },{
      path: '/TrackingSum',
      component: TrackingSum,
      children:[{
        path: '/TrackingSum',
        redirect: '/tracking'
      },{
        path:'/tracking',
        component:Tracking
      },{
        path:'/trackingPickup',
        component:tracking02
      },{
        path:'/trackingProducts',
        component:tracking03
      },{
        path:'/trackingPackage',
        component:tracking04
      },{
        path:'/trackingContrabands',
        component:tracking05
      }]
    },{
      path: '/product-list',
      component: ProductSum,
      children:[{
        path:'/product-list',
        redirect: '/directMail'
      },{
        path:'/directMail',
        component:Product01
      },{
        path:'/speedFreight',
        component:Product02
      },{
        path:'/financialProduct',
        component:Product03
      },{
        path:'/multiChannel',
        component:Product04
      }]
    },{
      path: '/HelpSum',
      component: HelpSum,
      children:[{
        path: '/HelpSum',
        redirect: '/help'
      },{
        path:'/help',
        component:Help01
      },{
        path:'/helpUser',
        component:Help02
      },{
        path:'/helpFAQ',
        component:Help03
      }]
    },{
      path: '/AboutSum',
      component: AboutSum,
      children:[{
        path: '/AboutSum',
        redirect: '/about'
      },{
        path:'/about',
        component:About01
      },{
        path:'/aboutRecruitment',
        component:About02
      },{
        path:'/aboutContact',
        component:About03
      },{
        path:'/aboutIntegrity',
        component:About04
      }]
    },{
      path: '/clauseConditions',
      component: Clause01,
    },{
      path: '/clauseService',
      component: Clause02,
    },{
      path: '/clausePrivacy',
      component: Clause03,
    },{
      path: '/cfClauseConditions',
      component: Clause05,
    },{
      path: '/cfClauseService',
      component: Clause06,
    },{
      path: '/cfClausePrivacy',
      component: Clause07,
    },{
      path: '/mcClauseConditions',
      component: ClauseMc1,
    },{
      path: '/mcClauseService',
      component: ClauseMc2,
    },{
      path: '/mcClausePrivacy',
      component: ClauseMc3,
    },{
      path: '/detail01',
      component: Detail01,
    },{
      path: '/detail02',
      component: Detail02,
    }]
  },
  {
    path: '/',
    component: Main,
  },
  {
    path: '/',
    redirect: '/'
  }
];
RouterConfig.scrollBehavior = function  (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  } else {
    return { x: 0, y: 0 }
  }
}
export default new Router(RouterConfig);



// WEBPACK FOOTER //
// ./src/router/index.js